// extracted by mini-css-extract-plugin
export default {"disabled":"style_disabled__x3oHo","axisControlContainer":"style_axisControlContainer__QvDEM","axisControl":"style_axisControl__r-6ah","yLimitInput":"style_yLimitInput__DiAgx"};